import { restPost, restPostClient } from "./RestClient";

export async function fetchFeatures() {
	const res = await restPost(`marketing/FetchFeatures`, {});
	return res.data;
}

export async function fetchPremiumFeatures(data) {
	const res = await restPostClient(`Client/FetchClientAppList`, data);
	return res.data;
}

export async function fetchFAQ(data) {
	const res = await restPost(`marketing/FetchFAQ`, data);
	return res.data;
}
//Blog
export async function fetchBlogPosts(data) {
	const res = await restPost(`marketing/FetchBlogPosts`, data);
	return res.data;
}
export async function fetchBlogPostContent(data) {
	const res = await restPost(`marketing/FetchBlogPostContent`, data);
	return res.data;
}

